import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import {
  applyBiddingIntradayOrderCsv,
  checkBiddingIntradayOrderCsv,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'
import type {
  ApplyBiddingIntradayOrderCsvRequestSchema,
  ApplyBiddingIntradayOrderCsvResponseSchema,
  CheckBiddingIntradayOrderCsvRequestSchema,
  CheckBiddingIntradayOrderCsvResponseSchema,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 時間前入札 CSV の Check mutation (docs/specs/bidding/intraday-csv-import.md
 * AC-BCI-001〜008)。副作用なし: 行ごとのプレビューと check_token を返すだけで
 * 注文は 1 件も作られない (common.md §3 の 2 段階分離の前段)。
 */
export function useCheckIntradayCsv(): UseMutationResult<
  MessageShape<typeof CheckBiddingIntradayOrderCsvResponseSchema>,
  ConnectError,
  MessageInitShape<typeof CheckBiddingIntradayOrderCsvRequestSchema>
> {
  return useMutation(checkBiddingIntradayOrderCsv)
}

/**
 * 時間前入札 CSV の Apply mutation (= check_token を引き換えて、 行ごとのエリアの
 * 承認モードどおりに承認申請または提出まで進める。 提出した札は JEPX へ送信される。
 * AC-BCI-011)。
 */
export function useApplyIntradayCsv(): UseMutationResult<
  MessageShape<typeof ApplyBiddingIntradayOrderCsvResponseSchema>,
  ConnectError,
  MessageInitShape<typeof ApplyBiddingIntradayOrderCsvRequestSchema>
> {
  return useMutation(applyBiddingIntradayOrderCsv)
}
